import React, { useEffect, useState } from 'react';
import { plansApi } from '../../services/api';
import logger from '../../utils/logger';

import { Link } from 'react-router-dom'
import Bluedots from '../../assets/images/blue_dotes.png'

function Pricing() {

    const [tabMenu, tabActive] = useState({ a: true });
    const [plans, setPlans] = useState([]);
    const [features, setFeatures] = useState([]);

    useEffect(() => {
        const loadData = async () => {
            try {
                const [plansRes, featuresRes] = await Promise.all([
                    plansApi.fetchAllPlans(),
                    plansApi.fetchAllFeatures(),
                ]);

                // Handle response structure - API returns { data: [...] }
                const plansArray = Array.isArray(plansRes) ? plansRes : (plansRes?.data || []);
                const featuresArray = Array.isArray(featuresRes) ? featuresRes : (featuresRes?.data || []);
                
                setPlans(plansArray);
                setFeatures(featuresArray);
            } catch (error) {
                logger.error('Failed loading pricing data', error);
            }
        };

        loadData();
    }, []);

    return (
        <>
            <section className="row_am pricing_section white_text" data-aos="fade-in" data-aos-duration={1500} >
                <div className="pricing_inner">
                    <div className="container">
                        <div className="dotes_blue">
                            <img src={Bluedots} alt="image" />
                        </div>
                        <div className="section_title" data-aos="fade-up" data-aos-duration={1500} data-aos-delay={300} >
                            <span className="title_badge">Planuri</span>
                            <h2>Alege-ți pachetul care ți se <span>potrivește</span></h2>
                        </div>
                        <ul className="nav nav-tabs" id="myTab" role="tablist" data-aos="fade-up" data-aos-duration={1500} >
                            <li className="nav-item" role="presentation">
                                <button className={`nav-link ${tabMenu.a && "active"}`}
                                onClick={() => tabActive({ a: true })} id="monthly-tab" data-toggle="tab" data-target="#monthly" 
                                    type="button" role="tab" aria-controls="monthly" aria-selected="true" >
                                    Lunar
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className={`nav-link ${tabMenu.b && "active"}`}
                               onClick={() => tabActive({ b: true })}  id="yearly-tab" data-toggle="tab" data-target="#yearly" type="button" role="tab" aria-controls="yearly" aria-selected="false" >
                                    Anual
                                </button>
                            </li>
                        </ul>
                        <div className="tab-content" id="myTabContent">
                            <div className={`tab-pane fade ${tabMenu.a && "show active"}`} id="monthly" role="tabpanel" aria-labelledby="monthly-tab" >
                                <div className="pricing_pannel">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="pannel_block" data-aos="fade-up" data-aos-duration={1500} >
                                                <div className="heading">
                                                    <h3>LUMO Starter</h3>
                                                    <span>Dedicat freelancerilor – 1 profesionist activ</span>
                                                </div>
                                                <div className="pricing">
                                                    <h3>
                                                        €9 <span>/lună</span>
                                                    </h3>
                                                </div>
                                                <ul className="features">
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Gratuit în primele 3 luni</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>1 profesionist activ</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Programări online nelimitate</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Notificări email + push</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Integrare social media</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Sistem de fidelizare (LUMO Rewards)</p>
                                                    </li>
                                                                                                   
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Statistici de activitate</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Email/SMS marketing</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Suport dedicat</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Campanii automate</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Vizibilitate extinsă în marketplace</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Raportare detaliată</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Featured Provider (poziționare specială)</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Conținut vizual personalizat</p>
                                                    </li>
                                                </ul>
                                                <div className="btn_block">
                                                    <Link to="/contact" className="btn color-lumo-orange puprple_btn ml-0">
                                                        Alege pachet
                                                    </Link>
                                                    <div className="btn_bottom border-color-lumo-orange" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="pannel_block highlited_block" data-aos="fade-up" data-aos-duration={1500} >
                                                <div className="heading">
                                                    <h3>LUMO Plus</h3>
                                                    <span>Dedicat micro-echipelor – până la 3 profesioniști
                                                    </span>
                                                    <span className="offer">Popular</span>
                                                </div>
                                                <div className="pricing">
                                                    <h3>
                                                        €19 <span>/lună</span>
                                                    </h3>
                                                </div>
                                                <ul className="features">
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Gratuit în prima lună</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>3 profesioniști activi</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Programări online nelimitate</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Notificări email + push</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Integrare social media</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Sistem de fidelizare (LUMO Rewards)</p>
                                                    </li>
                                                                                                   
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Statistici de activitate</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Email/SMS marketing</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Suport dedicat</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Campanii automate</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Vizibilitate extinsă în marketplace</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Raportare detaliată</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Featured Provider (poziționare specială)</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Conținut vizual personalizat</p>
                                                    </li>
                                                </ul>

                                                <div className="btn_block white_btn">
                                                    <Link to="/contact" className="btn color-lumo-orange puprple_btn ml-0">
                                                        Alege pachet
                                                    </Link>
                                                    <div className="btn_bottom border-color-lumo-orange" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="pannel_block" data-aos="fade-up" data-aos-duration={1500} >
                                                <div className="heading">
                                                    <h3>LUMO Pro</h3>
                                                    <span>Dedicat business-urilor medii și <br/> mari –  până la 10 profesioniști</span>
                                                </div>
                                                <div className="pricing">
                                                    <h3>
                                                        €39 <span>/lună</span>
                                                    </h3>
                                                </div>
                                                <ul className="features">
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Gratuit în prima lună</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Până la 10 profesioniști activi</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Programări online nelimitate</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Notificări email + push</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Integrare social media</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Sistem de fidelizare (LUMO Rewards)</p>
                                                    </li>
                                                                                                   
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Statistici de activitate</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Email/SMS marketing</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Suport dedicat</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Campanii automate</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Vizibilitate extinsă în marketplace</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Raportare detaliată</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Featured Provider (poziționare specială)</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Conținut vizual personalizat</p>
                                                    </li>
                                                </ul>
                                                <div className="btn_block">
                                                    <Link to="/contact" className="btn color-lumo-orange puprple_btn ml-0">
                                                        Alege pachet
                                                    </Link>
                                                    <div className="btn_bottom border-color-lumo-orange" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="pannel_block" data-aos="fade-up" data-aos-duration={1500} >
                                                <div className="heading">
                                                    <h3>LUMO Business</h3>
                                                    <span>Pentru business-uri care vor promovare activă & conținut profesionist</span>
                                                </div>
                                                <div className="pricing">
                                                    <h3>
                                                        €59 <span>/lună</span>
                                                    </h3>
                                                </div>
                                                <ul className="features">
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Profesioniști activi nelimitați</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Programări online nelimitate</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Notificări email + push</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Integrare social media</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Sistem de fidelizare (LUMO Rewards)</p>
                                                    </li>
                                                                                                   
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Statistici de activitate</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Email/SMS marketing</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Suport dedicat</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Campanii automate</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Vizibilitate extinsă în marketplace</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Raportare detaliată</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Featured Provider (poziționare specială)</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Conținut vizual personalizat</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Gratuit primele luni</p>
                                                    </li>
                                                </ul>
                                                <div className="btn_block">
                                                    <Link to="/contact" className="btn color-lumo-orange puprple_btn ml-0">
                                                        Alege pachet
                                                    </Link>
                                                    <div className="btn_bottom border-color-lumo-orange" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`tab-pane fade ${tabMenu.b && "show active"}`} id="yearly" role="tabpanel" aria-labelledby="yearly-tab" >
                                <div className="row">
                                <div className="col-md-3">
                                            <div className="pannel_block" data-aos="fade-up" data-aos-duration={1500} >
                                                <div className="heading">
                                                    <h3>LUMO Starter</h3>
                                                    <span>Dedicat freelancerilor – 1 profesionist activ</span>
                                                </div>
                                                <div className="pricing">
                                                    <h3>
                                                        €7.5 <span>/lună</span>
                                                    </h3>
                                                </div>
                                                <ul className="features">
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Gratuit în primele 3 luni</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>1 profesionist activ</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Programări online nelimitate</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Notificări email + push</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Integrare social media</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-check-circled" />
                                                        </span>
                                                        <p>Sistem de fidelizare (LUMO Rewards)</p>
                                                    </li>
                                                                                                   
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Statistici de activitate</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Email/SMS marketing</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Suport dedicat</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Campanii automate</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Vizibilitate extinsă în marketplace</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Raportare detaliată</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Featured Provider (poziționare specială)</p>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="icofont-close-circled" />
                                                        </span>
                                                        <p>Conținut vizual personalizat</p>
                                                    </li>
                                                </ul>
                                                <div className="btn_block">
                                                    <Link to="/contact" className="btn color-lumo-orange puprple_btn ml-0">
                                                        Alege pachet
                                                    </Link>
                                                    <div className="btn_bottom border-color-lumo-orange" />
                                                </div>
                                            </div>
                                </div>
                                    <div className="col-md-3">
                                        <div className="pannel_block highlited_block" data-aos="fade-up" data-aos-duration={1500} >
                                            <div className="heading">
                                                <h3>LUMO Plus</h3>
                                                <span>Dedicat micro-echipelor – până la 3 profesioniști
                                                </span>
                                                <span className="offer">Popular</span>
                                            </div>
                                            <div className="pricing">
                                                <h3>
                                                    €16.5 <span>/lună</span>
                                                </h3>
                                            </div>
                                            <ul className="features">
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Gratuit în prima lună</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>3 profesioniști activi</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Programări online nelimitate</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Notificări email + push</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Integrare social media</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Sistem de fidelizare (LUMO Rewards)</p>
                                                </li>
                                                                                            
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Statistici de activitate</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Email/SMS marketing</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Suport dedicat</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-close-circled" />
                                                    </span>
                                                    <p>Campanii automate</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-close-circled" />
                                                    </span>
                                                    <p>Vizibilitate extinsă în marketplace</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-close-circled" />
                                                    </span>
                                                    <p>Raportare detaliată</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-close-circled" />
                                                    </span>
                                                    <p>Featured Provider (poziționare specială)</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-close-circled" />
                                                    </span>
                                                    <p>Conținut vizual personalizat</p>
                                                </li>
                                            </ul>

                                            <div className="btn_block white_btn">
                                                <Link to="/contact" className="btn color-lumo-orange puprple_btn ml-0">
                                                    Alege pachet
                                                </Link>
                                                <div className="btn_bottom border-color-lumo-orange" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="pannel_block" data-aos="fade-up" data-aos-duration={1500} >
                                            <div className="heading">
                                                <h3>LUMO Pro</h3>
                                                <span>Dedicat business-urilor medii și <br/> mari – până la 10 profesioniști</span>
                                            </div>
                                            <div className="pricing">
                                                <h3>
                                                    €35.5 <span>/lună</span>
                                                </h3>
                                            </div>
                                            <ul className="features">
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Gratuit în prima lună</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Până la 10 profesioniști activi</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Programări online nelimitate</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Notificări email + push</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Integrare social media</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Sistem de fidelizare (LUMO Rewards)</p>
                                                </li>
                                                                                            
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Statistici de activitate</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Email/SMS marketing</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Suport dedicat</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Campanii automate</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Vizibilitate extinsă în marketplace</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Raportare detaliată</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Featured Provider (poziționare specială)</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-close-circled" />
                                                    </span>
                                                    <p>Conținut vizual personalizat</p>
                                                </li>
                                            </ul>
                                            <div className="btn_block">
                                                <Link to="/contact" className="btn color-lumo-orange puprple_btn ml-0">
                                                    Alege pachet
                                                </Link>
                                                <div className="btn_bottom border-color-lumo-orange" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="pannel_block" data-aos="fade-up" data-aos-duration={1500} >
                                            <div className="heading">
                                                <h3>LUMO Business</h3>
                                                <span>Dedicat business-urilor medii și <br/> mari – 4+ profesioniști</span>
                                            </div>
                                            <div className="pricing">
                                                <h3>
                                                    €54.5 <span>/lună</span>
                                                </h3>
                                            </div>
                                            <ul className="features">
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Profesioniști activi nelimitați</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Programări online nelimitate</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Notificări email + push</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Integrare social media</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Sistem de fidelizare (LUMO Rewards)</p>
                                                </li>
                                                                                            
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Statistici de activitate</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Email/SMS marketing</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Suport dedicat</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Campanii automate</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Vizibilitate extinsă în marketplace</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Raportare detaliată</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Featured Provider (poziționare specială)</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-check-circled" />
                                                    </span>
                                                    <p>Conținut vizual personalizat</p>
                                                </li>
                                                <li>
                                                    <span className="icon">
                                                        <i className="icofont-close-circled" />
                                                    </span>
                                                    <p>Gratuit primele luni</p>
                                                </li>
                                            </ul>
                                            <div className="btn_block ">
                                                <Link to="/contact" className="btn color-lumo-orange puprple_btn ml-0">
                                                    Alege pachet
                                                </Link>
                                                <div className="btn_bottom border-color-lumo-orange" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p className="contact_text text-center" data-aos="fade-up" data-aos-duration={1500} >
                                Ai întrebări ? <Link to="/contact">Contactează-ne</Link> pentru mai multe detalii
                                <br/>
                                Prețurile nu includ TVA
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Pricing